var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',{staticClass:"md-card-chart",attrs:{"data-count":_vm.hoverCount}},[_c('md-card-header',{class:[
      { [_vm.getClass(_vm.backgroundColor)]: true },
      { 'md-card-header-text': _vm.HeaderText },
      { 'md-card-header-icon': _vm.HeaderIcon }
    ]},[(_vm.chartInsideHeader)?_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}}):_vm._e(),_vm._t("chartInsideHeader")],2),_c('md-card-content',[(_vm.chartInsideContent)?_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}}):_vm._e(),_vm._t("content")],2),(!_vm.noFooter)?_c('md-card-actions',{attrs:{"md-alignment":"left"}},[_vm._t("footer")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }